import React, { useState, useEffect } from "react";
import { DocumentTypes } from "../enums/DocumentTypes";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";



export default function usePostGetDocuments() {
    const post = async (postData: DocumentTypes[] = null) => {
        const response = await axios.post("/DocumentApi/GetDocuments", postData);
        return response.data.UpdatedItem;
    }

    const { mutate, data, isPending, isError, isSuccess, error } = useMutation({
        mutationKey: ["GetDocuments"],
        mutationFn: post,
        onError: (error) => {
            console.log("%c GetDocuments ошибка:", "color: #f08181; font-weight: bold; font-size: 16px;", error);
        },
    });

    return { mutate, data, isPending, isError, isSuccess, error }
}